module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<header><h5 class="module-title">'+
((__t=( i18n.tc( "ControlDayAndNight", "Day and Night" ) ))==null?'':__t)+
'</h5></header><div id="enable-strip"><p class="error" v-show="model.modelError">ERROR! {{ model.modelError }}</p><dl v-show="model.nightModeEnabledError"><dd><p class="error">ERROR! {{ model.nightModeEnabledError }}</p></dd></dl><div class="input"><defa-radio-strip v-model="nightModeEnabledValue" :options="actionOptions" v-bind:class="{ errorState: model.nightModeEnabled === null}" v-on:input="save($event, \'nightModeEnabled\' )"></div></div><div data-region="day-and-night-container"></div><fieldset class="button-wrap"><button data-click="dayAndNight-close">'+
((__t=( i18n.tc("ControlDayAndNight", "Close") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
